/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.mtWatchOpenState();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }

  /**
   * Merino.tech: marks <html> with "mt-cart-open" while the cart drawer is open,
   * so the chat button steps back and never covers the drawer (style is added below).
   */
  mtWatchOpenState() {
    const sync = () => {
      document.documentElement.classList.toggle('mt-cart-open', this.getAttribute('aria-hidden') === 'false');
    };
    new MutationObserver(sync).observe(this, { attributes: true, attributeFilter: ['aria-hidden'] });
    sync();
  }
}

window.customElements.define('cart-drawer', CartDrawer);

/*
 * Merino.tech additions (Oct 2026).
 * 1. Chat button hides while the cart drawer is open (desktop and mobile).
 * 2. The ladder offer is applied as soon as something is added to the cart, without a tap on "Apply":
 *    - if the cart already carries a discount code, nothing is changed;
 *    - on pages with the ladder plaque (snippets/mt-qty-ladder) its own "Apply" is triggered, so the plaque stays
 *      the single source of the codes;
 *    - on pages without the plaque the code is chosen here. KEEP IN SYNC with snippets/mt-qty-ladder:
 *      deal window Oct 6 2026 00:00 ET -> Oct 8 2026 00:00 HST, LAYERUP15 / LAYERUP20 from $300;
 *      outside the window EQUINOX10 / EQUINOX15 from $300; $300 is counted after the any-order offer.
 * 3. After a code is applied the drawer is redrawn, so the discount line shows right away.
 */
(function () {
  if (window.__mtCartOffer) return;
  window.__mtCartOffer = true;

  const style = document.createElement('style');
  style.textContent = 'html.mt-cart-open #meri-ai-chat-root .meri-chat-launcher,' +
    'html.mt-cart-open #meri-ai-chat-root .meri-chat-nudge' +
    '{visibility:hidden!important;opacity:0!important;pointer-events:none!important}';
  document.head.appendChild(style);

  const DEAL_START = Date.UTC(2026, 9, 6, 4, 0, 0);
  const DEAL_END = Date.UTC(2026, 9, 8, 10, 0, 0);
  const TOP_TIER_MIN = 30000;
  let busy = false;

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }

  // The $300 tier is compared with the cart after the any-order offer (subtotal minus 15% in the deal, 10% outside it).
  function codeFor(subtotal) {
    const now = Date.now();
    const deal = now >= DEAL_START && now < DEAL_END;
    const afterOffer = Math.round(subtotal * (100 - (deal ? 15 : 10)) / 100);
    if (afterOffer >= TOP_TIER_MIN) return deal ? 'LAYERUP20' : 'EQUINOX15';
    return deal ? 'LAYERUP15' : 'EQUINOX10';
  }

  const nativeFetch = window.fetch;
  window.fetch = function (...args) {
    const url = (args[0] && args[0].url) || args[0] || '';
    const res = nativeFetch.apply(this, args);
    if (typeof url === 'string' && url.indexOf('/discount/') === 0) {
      res.then(() => setTimeout(refreshDrawer, 150)).catch(() => {});
    }
    return res;
  };

  function applyOffer() {
    if (busy) return;
    busy = true;
    window.fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        const codes = (cart.discount_codes || []).filter((d) => d && d.code && d.applicable !== false);
        if (!cart.item_count || codes.length) return null;
        const plaqueApply = document.querySelector('.mtw[data-mt-wknd] [data-mt-apply="1"]');
        if (plaqueApply) { plaqueApply.click(); return null; }
        const subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
        return window.fetch('/discount/' + encodeURIComponent(codeFor(subtotal || 0)), { credentials: 'same-origin' });
      })
      .catch(() => {})
      .finally(() => { busy = false; });
  }

  document.addEventListener('on:cart:add', () => setTimeout(applyOffer, 200));
})();